import type { ContentStatus } from '@confluence/content-types-header/entry-points/ContentStatus.tsx';

import { ContentTypesActionsService } from './content-types-actions-service.ts';
export const contentBoardStatusService = new ContentTypesActionsService<ContentStatus>();
